<script setup lang="ts">
import { computed } from "vue";
import { Bar } from "vue-chartjs";
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const props = withDefaults(
    defineProps<{
        chartdata: Record<string, unknown> | null;
        options: Record<string, unknown> | null;
        height?: number;
    }>(),
    { height: 400 },
);

const chartData = computed(() => props.chartdata ?? { datasets: [], labels: [] });
const chartOptions = computed(() => props.options ?? {});

/**
 * The charts run with `maintainAspectRatio: false`, so Chart.js sizes the canvas
 * from its offset parent. Without an explicitly sized wrapper it would measure the
 * card body, whose own height comes from the canvas — a circular measurement that
 * collapses the chart. vue-chartjs 3 supplied this wrapper itself; vue-chartjs 5
 * renders a bare canvas, so we provide it here.
 */
const wrapperStyle = computed(() => ({ height: `${props.height}px` }));
</script>

<template>
    <div class="chart-container" :style="wrapperStyle">
        <Bar :data="chartData" :options="chartOptions" />
    </div>
</template>

<style scoped>
.chart-container {
    position: relative;
    width: 100%;
}
</style>
